import { ExtendedGallery } from '../../../../../pages/HomepageRedesign/components';
import { ReviewsCarouselItem } from '../ReviewsCarouselItem';

import type { ReviewsCarouselItemProps } from '../reviewsData';

import styles from './MobileReviewsCarousel.module.css';
import { useState } from 'react';

const INITIAL_ACTIVE_ITEM = 1;

interface MobileReviewsCarouselProps {
  items: ReviewsCarouselItemProps[];
}

export const MobileReviewsCarousel = ({
  items,
}: MobileReviewsCarouselProps) => {
  const [activeItem, setActiveItem] = useState(INITIAL_ACTIVE_ITEM);

  const safeActiveItem = Math.max(0, Math.min(activeItem, items.length - 1));

  const handleSlideChange = (index: number) => {
    setActiveItem(index);
  };

  // FIXME: https://app.shortcut.com/farmersdog/story/136293/useslideshow-hook-doesn-t-respond-to-controlled-activeindex-changes
  // useEffect(() => {
  //   setActiveItem(1);
  // }, [selectedCategory]);

  return (
    <ExtendedGallery
      withDots
      isWide={false}
      id="reviews-carousel"
      label="User Testimonials"
      className={styles.gallery}
      activeIndex={safeActiveItem}
      slideClassname={styles.slide}
      onSlideChange={handleSlideChange}
    >
      {items.map((item, index) => (
        <ReviewsCarouselItem
          key={item.id}
          {...item}
          isActive={index === safeActiveItem}
        />
      ))}
    </ExtendedGallery>
  );
};
